
import React from 'react';
import { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
// import CustomButtons from '../../components/Elements/Buttons/customButton';
// import CustomTittle from '../../components/Elements/customTittle/customTittle';
// import Header from '../../components/Elements/header/header';



import "./userDetailPopUp.css"




 
const UserDetailPopUp = (props) => {
    const [isHint, seIsHint] = useState(false)
    let isForce = false;
    
    if(props.force != undefined){
        isForce = props.force
       
    }

   
   
    return <> 

    {props.force != undefined?<div id="czyToWchodzi?" className='UserDetailPopUp'>
     <p>{props.title}</p>
     <div className='contentWithHint_and_icon'>
     <div className={props.hint != undefined?'content_and_icon_hint':"content_and_icon"}>
        <p className='labelP'>{props.label}</p>
        {props.hint != undefined?<p className='hintP'>({props.hint})</p>:""}
        
     </div>
      {props.icon!=undefined?<div className='svg_nav' onClick={props.onclick}>
     {props.icon}
     </div>:""}
     </div>
    </div>: <div className='UserDetailPopUp' >
     <p>{props.title}</p>
     <div className='contentWithHint_and_icon'>
     <div className={props.hint != undefined?'content_and_icon_hint':"content_and_icon"}>
        <p className='labelP'>{props.label}</p>
        {props.hint != undefined?<p className='hintP'>({props.hint})</p>:""}
        
     </div>
      {props.icon!=undefined?<div className='svg_nav' onClick={props.onclick}>
     {props.icon}
     </div>:""}
     </div>
    </div>}
    </>;
    }

export default UserDetailPopUp;
